module.exports = __webpack_public_path__ + "static/media/error.64fe0f6e.jpg";